
import React, { useEffect, useState } from 'react';
import '/src/styles/tables.css'
import { useNavigate } from 'react-router-dom';
import '/src/styles/index.css';
import refreshToken from '../../../../../../refreshToken';
import adapter from '../../../../../../adapter';
import Rollbar from 'rollbar';
const rollbar = new Rollbar({
  accessToken: '6dac23a10b4d4eb797cb71bd64e0d80f',
  environment: 'testenv',
});
const stats = ({selectedBotId}) => {
    const storedData = JSON.parse(localStorage.getItem('dashboardData'));
    const dashboardData = storedData ? storedData: null;
 
    const [statsData, setstatsData] = useState('');
    const navigate = useNavigate();
    const getstats = async () => {
        try {
            const data = {
              route: 'getstatss',
              user_tg_id : dashboardData.user['telegram_id'],
              access_token: dashboardData.token,
              bot_id: selectedBotId
            };
            const response = await adapter.post('', data);
            if (response.data.result === 'success') {
                setstatsData(response.data.array);
            }else if(response.data.result === 'error' && response.data.text === 'Token is expired'){
                try {
                  const refreshTokenResult = await refreshToken();
                  if (refreshTokenResult === 'logout') {
                    navigate('/', { replace: true });
                  }else{
                    dashboardData.token = refreshTokenResult;
                    const data = {
                    route: 'getstatss',
                    user_tg_id : dashboardData.user['telegram_id'],
                    access_token: dashboardData.token,
                    bot_id: selectedBotId
                    };
                    const response = await adapter.post('', data);
                    if (response.data.result === 'success') {
                        setstatsData(response.data.array);
                    }
                    else {
                        console.log(response.data);
                      }
                    }
                } catch (error) {
                    console.error(error);
                }
            }else if(response.data.text === 'bot is not connected'){
                  setstatsData('');
            }
            else {
             console.log('Произошла ошибка:  ' + response.data.text);
            }
          } catch (error) {
            console.error(error);
            rollbar.error('Error during request:', error);
          }
    } 

    useEffect(() => {
        getstats();
    },[] )

    return(
        <table className='stats-table'>
            <tr className='stats-table__header'>
                <th>
                    Данные о канале
                </th>
                <th>
                    Дата подключения бота
                </th>
                <th>
                    Аудитория
                </th>
            </tr>
            <tbody>
                {statsData.length !== 0 ? (
                    statsData.map((stats, index)=>
                    <tr className='stats-table__row'>
                        <td>
                            <strong class="stats-name">{stats.name}</strong>
                            <p class="stats-username">{stats.type}</p>
                        </td>
                        <td>
                            {stats.date}
                        </td>
                        <td>
                            <strong className='subscribers'>{stats.subscribers}</strong>
                            <p>Подписчиков</p>
                        </td>
                    </tr> 
                    )
                ): (
                    <tr>
                        <td colSpan={6} className="stats-table_row">У этого бота нет каналов !</td>
                    </tr>
                    
                )}
                
            </tbody>
            <div class="statss-list">
                <div class="statss-list__item">
                    
                    <div>
                        
                    </div>
                </div>
            </div>
        </table>
     
            
        
    );

}
    
    
    
    
export default stats;